import { render, staticRenderFns } from "./page-active-log.vue?vue&type=template&id=0d28b53e&scoped=true&"
import script from "./page-active-log.vue?vue&type=script&lang=js&"
export * from "./page-active-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28b53e",
  null
  
)

export default component.exports